import { createApp } from "vue";
import * as utils from "./util";
import { RULES } from "./rules";
import en from '../../static/lib/locale/lang/en.json';
import { useNetwork } from '@/js/networkMinxin';

export const locale = en || {};

async function loadLocale() {
  try {
    const langModule = await import(`../../static/lib/locale/lang/en.json`);
    sakura.locale = langModule.default; // Assign the actual JSON data
  } catch (error) {
    console.error("Failed to load locale file:", error);
  }
}

// Load language data on initialization
loadLocale();


// const lang = import(`../../static/lib/locale/lang/en.json`);

const verifyRequired = (name) => {
  let message = sakura.locale.rules.required;
  return message.replace("${name}", name);
};

const codeMessage = (code) => {
  let list = sakura.locale.message;
  let arr = list.filter((item) => item.code === code);
  return arr.length ? arr[0].message : "";
};

const sakuraMessage = (code) => {
  let $codeMessage = sakura.codeMessage;
  utils.MESSAGE_INFO(code == 0 ? "success" : "error", $codeMessage(code));
};

const initNetwork = (port, networkLan, priority = [], arr = []) => {
  arr = [...new Set(arr.concat(networkLan["mode"]))];

  if (!networkLan._isEnabledTu) {
    if (port.powerUsage > 0 && port.poeIsValid == 3)
      networkLan["borderStatus"] = "connected-powered";
    else if (port.linkState == 0) networkLan["borderStatus"] = "connected";
    else networkLan["borderStatus"] = "";

    if (port.portState == 2) {
      networkLan["status"] = "disabled";
      if (networkLan._isEnabled) networkLan["isEnabled"] = false;
    } else if (port.portState == 1) {
      networkLan["status"] = "available";
      if (networkLan._isEnabled) networkLan["isEnabled"] = true;
    } else {
      networkLan["status"] = "";
      if (networkLan._isEnabled) networkLan["isEnabled"] = true;
    }

    if (port.pvid < 1) {
      networkLan["status"] = "disabled";
      if (networkLan._isEnabled) networkLan["isEnabled"] = false;
    } else {
      networkLan["status"] = "";
      if (networkLan._isEnabled) networkLan["isEnabled"] = true;
    }
  }

  if (port.percetUtilizationTransmitted >= 95 || port.percetUtilizationReceived >= 95) {
    arr.push("warning");
  } else {
    arr = arr.filter((key) => key != "warning");
  }

  if (port.stpMode == 1) {
    arr.push("block");
  } else {
    arr = arr.filter((key) => key != "block");
  }

  if (port.adminState == 0) {
    arr.push("adminDown");
  } else {
    arr = arr.filter((key) => key != "adminDown");
  }

  if (port.portMode == 3) {
    arr.push("trunk");
  } else {
    arr = arr.filter((key) => key != "trunk");
  }

  if (port.autoTrunk == 1) {
    arr.push("autoTrunk");

    if (port.switchportMode != 8) {
      arr = arr.filter(key => key != 'autoTrunk');
    }
    networkLan['isEnabledTu'] = false;
    networkLan['isEnabled'] = false;
    networkLan['status'] = 'disabled';
  } else {
    arr = arr.filter((key) => key != "autoTrunk");
  }

  if (port.poeIsValid == 1) {
    arr.push("poeDisabled");
  } else if (port.poeIsValid == 3) {
    arr.push("poe");
  } else {
    arr = arr.filter((key) => key != "poe" && key != "poeDisabled");
  }

  let speedKey = utils.SPEED_MAP(port.portCapability);
  let keys = ["S", "S+", "S28", "QS+", "Q28", "S56"];
  if (port.moduleType > 0) {
    switch (speedKey) {
      case "CAP_PORTSPEED_1000":
        arr.push("S");
        break;
      case 'CAP_PORTSPEED_2P5G':
        arr.push('S');
        break;
      case "CAP_PORTSPEED_10G":
        arr.push("S+");
        break;
      case "CAP_PORTSPEED_25G":
        arr.push("S28");
        break;
      case "CAP_PORTSPEED_40G":
        arr.push("QS+");
        break;
      case "CAP_PORTSPEED_100G":
        arr.push("Q28");
        break;
      case "CAP_PORTSPEED_50G":
        arr.push("S56");
        break;
      default:
        arr = arr.filter((key) => !keys.includes(key));
        break;
    }
  } else {
    arr = arr.filter((key) => !keys.includes(key));
  }

  if (port.dot1xStatus == 1) {
    arr.push("lock");
  } else if (port.dot1xStatus == 2) {
    arr.push("unlock");
  } else {
    arr = arr.filter((key) => key != "lock" && key != "unlock");
  }

  if (port.shureLearn) {
    arr.push("dynamic");
  } else {
    arr = arr.filter((key) => key != "dynamic");
  }
  const { vlanListGlobal } = useNetwork();
  if (
    vlanListGlobal?.value &&
    Array.isArray(port.vlan) &&
    port.vlan.length > 0
  ) {
    const matchedProfile = vlanListGlobal.value
      .filter(profile => profile.vlans?.length > 1)
      .find(profile => port.vlan.some(vlanId => vlanId === profile.id));

    if (matchedProfile?.vlans) {
      const hasUntaggedPort = matchedProfile.vlans.some(vlan =>
        Array.isArray(vlan.ports?.untagged) &&
        vlan.ports.untagged.includes(port.portNum)
      );

      if (hasUntaggedPort) {
        arr = arr.filter(mode => mode !== 'trunk');
      }
    }
  }

  networkLan["mode"] = arr;
  networkLan["priority"] = priority;
  return networkLan;
};

// Create sakura object
export const sakura = {
  locale,
  rules: RULES,
  verifyRequired,
  codeMessage,
  sakuraMessage,
  sakuraMessageInfo: utils.MESSAGE_INFO,
  formatDate: utils.FORMAT_DATE,
  deepCopy: utils.DEEPCOPY,
  loadFormData: utils.LOAD_DATA,
  conversionList: utils.CONVERSIONTABLE,
  capitalize: utils.STORE.CAPITALIZE,
  debounce: utils.DEBOUNCE,
  unique: utils.UNIQUE,
  parse: utils.PARSE,
  parseMultiple: utils.PARSE_MULTIPLE,
  stringifyMultiple: utils.STRINGIFY_MULTIPLE,
  deleteConfirm: utils.DELETE_CONFIRM,
  initNetwork,
  isEqualIpAddress: utils.ISEQUAL_IPADDRESS,
  isCorrectIpRange: utils.IS_CORRECT_IP_RANGE,
  xor: utils.XOR,
  query_subnet_mask: utils.QUERY_SUBNET_MASK,
  initNetworkColumn: utils.INIT_NETWORK_COLUMN,
  get_network_broadcast_addr: utils.GET_NETWORK_BROADCAST_ADDR,
  double_array: utils.DOUBLE,
  decimal_ufunc: utils.DECIMAL_UFUNC,
  shure_default: utils.SHURE_DEFAULT,
  listFilter: utils.LIST_FILTER,
  queryPortList: utils.QUERY_PORT_LIST,
  speed_list: utils.SPEED_LIST,
  enum: locale.conversion,
  isShure: utils.CHECK_SHURE,
  vlanTypeMap: utils.VLANTYPE_MAP,
  isKramer: utils.CHECK_KRAMER,
  speedMap: utils.SPEED_MAP,
  isPoly: utils.CHECK_POLY,
  isShureBrother: utils.CHECK_SHURE_BROTHER,
  contrastColor: utils.CONTRAST_COLOR,
  isHarman: utils.CHECK_HARMAN,
  isAvid: utils.CHECK_AVID,
};

// Export a function to register it globally in Vue 3
export function registerSakura(app) {
  app.config.globalProperties.$sakura = sakura;
}
